import React, { useContext, useEffect, useRef, useState } from 'react'
import moment from 'moment'
import Grid from '@mui/material/Grid'
import API from '../../../../../services/API'
import DetailsBox from '../../../../../components/Cards/DetailsBox'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import LinearProgress from '@mui/material/LinearProgress'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import AddCommentIcon from '@mui/icons-material/AddComment'
import ComposeMessage from './ComposeMessage'
import { TenantSettingsContext } from '../../../../../App'

const Messages = ({ eventID }) => {
  const [messages, setMessages] = useState([])
  const [fetchError, setFetchError] = useState(false)
  const [loading, setLoading] = useState(true)
  const [openCompose, setOpenCompose] = useState(false)
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig

  useEffect(() => {
    API.get('/client-portal/event-messages/' + eventID)
      .then((res) => {
        if (res.status === 200) {
          setMessages(res.data)
        } else {
          setFetchError(true)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Grid item xs={12} md={6} lg={4}>
      <DetailsBox
        title="Messages"
        buttonRight={
          <IconButton onClick={() => setOpenCompose(true)}>
            <AddCommentIcon color="anPurple" />
          </IconButton>
        }
      >
        {loading && <LinearProgress />}
        {fetchError && (
          <Alert severity="error">
            Unable to get messages. Please try again later.
          </Alert>
        )}
        <Stack
          maxHeight="200px"
          overflow="auto"
          gap={1}
          border={messages.length > 0 && 'solid 1px'}
          padding={1}
          divider={<Divider />}
          component={messages.length > 0 && Paper}
          borderRadius={1}
        >
          {messages
            .sort((a, b) => moment(b.date) - moment(a.date))
            .map((message) => (
              <Box key={message._id} padding={1}>
                <Stack>
                  <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    alignItems={{ xs: 'flex-start', md: 'center' }}
                    justifyContent={{ xs: 'center', md: 'space-between' }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={{ xs: 1, md: 2 }}
                    >
                      <Typography variant="title3">
                        {message.by.firstName} {message.by.lastName}
                      </Typography>
                      {message.by.employee && (
                        <Chip
                          color="info"
                          label={orgSettings?.orgShortName ?? 'Provider'}
                          size="small"
                          sx={{ borderRadius: 1 }}
                        />
                      )}
                    </Stack>
                    <Typography variant="caption">
                      {moment(message.date).format('Do MMM YYYY HH:mm')}
                    </Typography>
                  </Stack>
                  <Typography variant="body2">{message.comment}</Typography>
                </Stack>
              </Box>
            ))}
        </Stack>
      </DetailsBox>
      <ComposeMessage
        open={openCompose}
        onClose={() => setOpenCompose(false)}
        setMessages={setMessages}
        eventID={eventID}
      />
    </Grid>
  )
}

export default Messages
